import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { GISConfig } from "../../../gis/models/gis-config.model";
import { SubHeader } from '../../../core/models/sub-header.model';

// Services
import { WellViewerService } from "../../services/well-viewer.service";

import { SubHeaderService } from '../../../core/services/sub-header.service';

@Component({
    selector: "well-viewer",
    templateUrl: "./well-viewer.component.html",
    styleUrls: ["./well-viewer.component.scss"],
    standalone: false
})
export class WellViewerComponent implements OnInit {
    // HTML Div for the map
    @ViewChild("wellViewerNode", { static: true }) public wellViewerNode: ElementRef;
    // Legend Info
    allLayers: any[] = [];
    config: GISConfig;
    subHeader = new SubHeader({
        title: "Well Map", buttons: []
    });

    constructor(
        public readonly wellViewerService: WellViewerService,
        public subHeaderService: SubHeaderService
    ) {
        this.config = window["GIS.Conf"] as GISConfig;

        this.wellViewerService.layerList$.subscribe(data => {
            this.allLayers = data;
        });
    }

    ngOnInit(): void {
        this.subHeaderService.updateSubHeader(this.subHeader);
    }

    async ngAfterViewInit(): Promise<void> {
        this.wellViewerService.initialize2dView(this.wellViewerNode).then(async () => {
            console.log("map loaded: ");
            // TODO: MOVE THESE TO CONFIG
            let layer1Promise = this.wellViewerService.loadFeatureLayer(this.config.wellViewerLandBase, true);
            let layer2Promise = this.wellViewerService.loadFeatureLayer(this.config.wellViewerPublicWells, false);
            let layer3Promise = this.wellViewerService.loadFeatureLayer(this.config.wellViewerCEA, false);
            let layer4Promise = this.wellViewerService.loadFeatureLayer(this.config.wellViewerEarthQuakes, false);
            let layer5Promise = this.wellViewerService.loadFeatureLayer(this.config.wellViewerNotificationAreas, false);
            Promise.all([layer1Promise, layer2Promise, layer3Promise, layer4Promise, layer5Promise]).then(
                values => {
                    console.log("layers----->", values);
                });
        });
    }

    selectedChanged(layerId: string): void {
        this.wellViewerService.toggleLayer(layerId);
    }


}
